var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntellijOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "intelij",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa930d}.cls-2{fill:#136ba2}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "original"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.55 64.73a17.08 17.08 0 1 0 17.08-17.09A17.11 17.11 0 0 0 5.55 64.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.48 4.73c-9.39 0-15 7.56-15 20.23v77.8c0 12.66 5.59 20.23 15 20.23s15-7.56 15-20.23V25c-.03-12.7-5.63-20.27-15-20.27zM81.25 6.38H19.88a14.92 14.92 0 0 0 0 29.81v.11h31.41v28.4a28.7 28.7 0 0 1-28.63 28.7h-.77l-.08.1c-.42 0-.85-.07-1.29-.07a14.94 14.94 0 1 0 0 29.87c.45 0 .9 0 1.34-.07v.05h.78a58.65 58.65 0 0 0 58.61-58.55v-.54-9.59-.11V6.38z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijOriginal);
export default __webpack_public_path__ + "static/media/IntellijOriginal.8292eb3cde4a565e017dc8dcb49bdc24.svg";
export { ForwardRef as ReactComponent };